import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, CircularProgress } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
// import { requestForToken, onMessageListener, messaging } from "./firebase";
// Components
import LoginPage from './Pages/Login/login';
import SleepStories from './Pages/care/sleep-stories';
import Forgotpassword from './Pages/Login/forgotPassword';
import Home from './Pages/home/home';
import HealthSurvey from './Pages/survey/HealthSurvey';
import Navbar from './Pages/navbar/index';
import {
  DailyBreathing,
  RejuvenateSounds,
  EchoSoundscapes,
  SoundMeditation
} from './Pages/care/care';
import MoodCheckin from './Pages/care/mood-checkin';
import GratitudeJournal from './Pages/care/GratitudeJournal';
import Care from './Pages/care/care';
import Converse from './Pages/converse/converse';
import AppointmentBooking from './Pages/consult/AppointmentBooking';
import Profile from './Pages/home/Profile';
import Progress from "./Pages/home/Progress";
import LearnWithEcho from "./Pages/home/LearnwithEcho";
import MyAppointments from './Pages/home/Appointment';
import ResetPassword from './Pages/Login/resetPassword';
import TestNotification from './TestNotification.jsx';
import Insights from './Pages/home/Insights.jsx';
import { postUserUsageTime } from './service/insights.js';
import SoundTherapy from './Pages/home/SoundTherapy.jsx';
import EchoSounds from './Pages/care/echo-sounds.jsx';
import VerifyEmail from './Pages/Login/verifyEmail.jsx';
import DecodeStress from './Pages/home/decodeStress.jsx';
import AssessmentFlow from './Pages/home/AssessmentFlow.jsx';
import ResultPage from './Pages/home/ResultPage.jsx';
import STIASurvey from './Pages/survey/STIASurvey.jsx';
import ChooseAssessment from './Pages/survey/ChooseAssessment.jsx';
import GlobalChatNotifier from './components/GlobalChatNotifier.jsx';
import AboutThisReport from './Pages/survey/AboutThisReport.jsx';

function ProtectedRoute({ children }) {
  const domain = localStorage.getItem("domain");
  const email = localStorage.getItem("email");
  const institution = localStorage.getItem("institution");
  const isEmailVerified = localStorage.getItem("isEmailVerified");

  console.log("isEmailVerified", isEmailVerified)

  const isLoggedIn =
    domain &&
    email &&
    institution;

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Layout
function AppLayout() {
  const location = useLocation();

  const user = localStorage.getItem("user");
  const expiry = localStorage.getItem("userExpiry");
  const now = new Date().getTime();
  const userData = user ? JSON.parse(user) : null;
  const accountType = userData?.account_type;

  const userId = userData?.id; // Get user_id from user object instead of localStorage

  const sessionStartRef = useRef(Date.now());
  const apiCalledRef = useRef(false);
  const fiveMinTimerRef = useRef(null);

  useEffect(() => {
    if (!userId) return;

    // ⏱ Start 5-minute timer
    fiveMinTimerRef.current = setTimeout(() => {
      if (!apiCalledRef.current) {
        postUserUsageTime(userId, 300);
        apiCalledRef.current = true;
      }
    }, 5 * 60 * 1000); // 5 minutes

    // 🔴 Handle page unload / refresh / close
    const handleUnload = () => {
      if (apiCalledRef.current) return;

      const timeSpentSeconds = Math.floor(
        (Date.now() - sessionStartRef.current) / 1000
      );

      console.log('🕐 Usage time tracking:', { userId, timeSpentSeconds });

      if (timeSpentSeconds > 0) {
        postUserUsageTime(userId, timeSpentSeconds);
        apiCalledRef.current = true;
      }
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      clearTimeout(fiveMinTimerRef.current);
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [userId]);

  const isLoggedIn = user && expiry && now < parseInt(expiry, 10);

  return (
    <>
      {/* Global chat notification listener - works on all pages */}
      <GlobalChatNotifier />

      {/* Show Navbar only on specific routes */}
      {[
        '/home',
        '/care',
        '/echo-sounds',
        '/converse',
        '/appointmentbooking',
        '/consult',
        '/echosound',
        '/daily-breathing',
        '/rejuvenate-sounds',
        '/echo-soundscapes',
        '/sound-meditation',
        '/sleep-stories',
        '/mood-checkin',
        '/gratitude-checkin',
        '/profile',
        '/insights',
        '/appointments',
        '/family',
        '/counseller',
        '/veiwappointments',
        '/HealthSurvey',
        '/admin',
        '/admin/appointments'
      ].includes(location.pathname) && <Navbar />}

      <Routes>
        {/* 🟢 Public routes – accessible to everyone */}
        <Route path="/" element={isLoggedIn ? <Navigate to={"/home"} replace /> : <LoginPage />} />
        {/* <Route path="/" element={isLoggedIn ? <Navigate to={"/home"} replace /> : <LandingPage />} /> */}



        <Route path="/forgotpassword" element={<Forgotpassword />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* 🔵 User-only routes */}
        <Route
          path="/home"
          element={
            <ProtectedRoute allowedFor="user">
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/about-report"
          element={<AboutThisReport />}
        />

        <Route
          path="/sound-therapy"
          element={
            <SoundTherapy />
          }
        />
        <Route
          path="/echo-sounds"
          element={<EchoSounds />}
        />
        <Route
          path="/decode-stress"
          element={<DecodeStress />}
        />
        <Route
          path="/assessment-flow"
          element={<AssessmentFlow />}
        />
        <Route
          path="/result"
          element={<ResultPage />}
        />
        <Route
          path="/care"
          element={
            <ProtectedRoute allowedFor="user">
              <Care />
            </ProtectedRoute>
          }
        />
        <Route
          path="/converse"
          element={
            <ProtectedRoute allowedFor="user">
              <Converse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/consult"
          element={
            <ProtectedRoute allowedFor="user">
              <AppointmentBooking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/insights"
          element={
            <ProtectedRoute allowedFor="user">
              <Insights />
            </ProtectedRoute>
          }
        />
        <Route
          path="/daily-breathing"
          element={
            <ProtectedRoute allowedFor="user">
              <DailyBreathing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rejuvenate-sounds"
          element={
            <ProtectedRoute allowedFor="user">
              <RejuvenateSounds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/echo-soundscapes"
          element={
            <ProtectedRoute allowedFor="user">
              <EchoSoundscapes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sound-meditation"
          element={
            <ProtectedRoute allowedFor="user">
              <SoundMeditation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sleep-stories"
          element={
            <ProtectedRoute allowedFor="user">
              <SleepStories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mood-checkin"
          element={
            <ProtectedRoute allowedFor="user">
              <MoodCheckin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gratitude-checkin"
          element={
            <ProtectedRoute allowedFor="user">
              <GratitudeJournal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/insights"
          element={
            <ProtectedRoute allowedFor="user">
              <Progress />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedFor="user">
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/appointments"
          element={
            <ProtectedRoute allowedFor="user">
              <MyAppointments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/learn-with-echo"
          element={
            <ProtectedRoute allowedFor="user">
              <LearnWithEcho />
            </ProtectedRoute>
          }
        />
        <Route
          path="/health-survey"
          element={
            <ProtectedRoute allowedFor="user">
              <HealthSurvey />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stia-survey"
          element={
            <ProtectedRoute allowedFor="user">
              <STIASurvey />
            </ProtectedRoute>
          }
        />
        <Route
          path="/choose-assessment"
          element={
            <ProtectedRoute allowedFor="user">
              <ChooseAssessment />
            </ProtectedRoute>
          }
        />

        {/* 🔴 Default fallback – if user tries an invalid path */}
        <Route
          path="*"
          element={
            isLoggedIn ? (
              <Navigate to="/home" replace />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>

    </>
  );
}

// Main App
function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <BrowserRouter
            future={{ v7_startTransition: true }}
          >
            <AppLayout />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
